import { useEffect, useRef } from 'react';
import { KeycloakService } from '../services/keycloakService';

interface UseTokenRefreshOptions {
  refreshInterval?: number;
  onRefreshSuccess?: () => void;
  onRefreshError?: () => void;
}

export const useTokenRefresh = ({
  refreshInterval = 2 * 60 * 1000, // 2 minutes default
  onRefreshSuccess,
  onRefreshError
}: UseTokenRefreshOptions = {}) => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (KeycloakService.isLoggedIn()) {
      intervalRef.current = setInterval(() => {
        if (KeycloakService.isLoggedIn()) {
          console.log('Próba automatycznego odświeżenia tokenu...');
          KeycloakService.updateToken()
            .then((refreshed) => {
              if (refreshed) {
                console.log('Token został odświeżony automatycznie');
                onRefreshSuccess?.();
              }
            })
            .catch((error) => {
              console.error('Błąd automatycznego odświeżania tokenu:', error);
              onRefreshError?.();
            });
        }
      }, refreshInterval);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [refreshInterval, onRefreshSuccess, onRefreshError]);

  return {
    clearRefreshInterval: () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }
  };
};